import React from 'react';
import { Tooltip } from '@panwds/react-ui';
import { CircleCheckIcon, ExclamationCircleIcon, BanIcon, SpinnerIcon } from '@panwds/icons';

type StatusType = 'success' | 'failed' | 'enabled' | 'disabled' | 'pending';

interface StatusDisplayProps {
    status: StatusType;
    text: string;
    tooltipText?: string;
}

const StatusDisplay: React.FC<StatusDisplayProps> = ({ status, text, tooltipText }) => {
    const icon = (() => {
        switch (status) {
            case 'success':
            case 'enabled':
                return <CircleCheckIcon size="xs" className="tw-text-teal-600 dark:tw-text-dark-bg-teal" />;
            case 'failed':
                const failedIcon = <ExclamationCircleIcon size="xs" className="tw-text-red-500 dark:tw-text-dark-bg-red" />;
                return tooltipText ? (
                    <Tooltip label={tooltipText}>{failedIcon}</Tooltip>
                ) : failedIcon;
            case 'disabled':
                return <BanIcon size="xs" className="tw-text-red-600 dark:tw-text-dark-bg-red" />;
            case 'pending':
                return <SpinnerIcon size="xs" className="tw-text-orange-400 dark:tw-text-dark-bg-orange" />;
            default:
                return null;
        }
    })();

    return (
        <span className="tw-inline-flex tw-items-center tw-gap-1">
            {icon}
            <span>{text}</span>
        </span>
    );
};

export default StatusDisplay;
